module.exports = __webpack_public_path__ + "resources/img/img-zenius-ems-02-m-en.fbe6b59e426c54137ca251104c9d5cd9.png";